module.exports = __webpack_public_path__ + "856bca25c1c2cbaf608d598f844c1a05.jpg";